<div class="container-fluid" style="position: relative; height: 100vh; padding-left: 3rem;">

  <div class="d-flex justify-content-center mt-5 mb-5">

    <div class="change-password-layout container-fluid"
      [ngClass]="isFirstTimeChange ? 'form-content shadow-5' : 'col-md-5'">
      <div class="row justify-content-center" [ngClass]="isFirstTimeChange ? 'form-first-time' : 'form'">
        <h2 class="reset-password-title" style="text-align: center;" *ngIf="isFirstTimeChange">Choose your Password</h2>
        <form class="text-center row g-3" [formGroup]="form" (ngSubmit)="onClickSubmit()" novalidate>
          <div class="col-md-12 text-start">
            <p class="text-muted my-2" style="font-size: 0.9rem;" *ngIf="isFirstTimeChange">Please choose a memorable
              password to use in place of the one-time password.</p>
            <label for="currentPassword" class="form-label" *ngIf="!isFirstTimeChange">Current Password</label>
            <label for="currentPassword" class="form-label" *ngIf="isFirstTimeChange">One-time Password</label>

            <input type="password" class="form-control" id="currentPassword" formControlName="currentPassword"
              [ngClass]="{ 'is-invalid': submitted && formControl['currentPassword'].errors }">
            <div *ngIf="submitted && formControl['currentPassword'].errors" class="invalid-feedback">
              <div *ngIf="formControl['currentPassword'].errors['required'] && !isFirstTimeChange">
                Current Password is required
              </div>
              <div *ngIf="formControl['currentPassword'].errors['required'] && isFirstTimeChange">
                One-time Password is required
              </div>
            </div>
          </div>
          <br>
          <hr>
          <br>
          <div class="col-md-12 text-start">
            <label for="newPassword" class="form-label">New Password</label>
            <div class="input-group">
              <input [type]="newPasswordType ? 'text' : 'password'" class="form-control" id="newPassword"
                formControlName="newPassword"
                [ngClass]="{ 'is-invalid': submitted && formControl['newPassword'].errors }"
                (focus)="onNewPasswordFocus()" (blur)="onNewPasswordBlur()" />
              <div class="input-group-append">
                <span class="input-group-text" [ngClass]="{
                              'custom-icon-button1': !newPasswordType,
                              'custom-icon-button2': newPasswordType
                              }" (click)="toggleNewPasswordTextType()"></span>
              </div>
            </div>
            <div *ngIf="submitted && formControl['newPassword'].errors" class="invalid-feedback d-block">
              <div *ngIf="formControl['newPassword'].errors['required']">
                New Password is required
              </div>
              <div *ngIf="formControl['newPassword'].errors['invalid']">
                Invalid Password format
              </div>
              <div *ngIf="formControl['newPassword'].errors['minlength']">
                Password must be at least 8 characters
              </div>
            </div>
            <app-password-strength-bar *ngIf="showPasswordStrength" barLabel="Password Strength"
              [passwordToCheck]="form.controls['newPassword'].value"
              (onPasswordChange)="passwordChanged($event)"></app-password-strength-bar>
          </div>
          <div class="col-md-12 text-start">
            <label for="confirmPassword" class="form-label">Confirm Password</label>
            <div class="input-group">
              <input [type]="confirmPasswordType ? 'text' : 'password'" class="form-control" id="confirmPassword"
                formControlName="confirmPassword"
                [ngClass]="{ 'is-invalid': submitted && formControl['confirmPassword'].errors }" />
              <div class="input-group-append">
                <span class="input-group-text" [ngClass]="{
                            'custom-icon-button1': !confirmPasswordType,
                            'custom-icon-button2': confirmPasswordType
                            }" (click)="toggleConPasswordTextType()">
                </span>
              </div>
            </div>
            <div *ngIf="submitted && formControl['confirmPassword'].errors" class="invalid-feedback d-block">
              <div *ngIf="formControl['confirmPassword'].errors['required']">
                Confirm Password is required
              </div>
              <div *ngIf="formControl['confirmPassword'].errors['matching']">
                Doesn't match
              </div>
            </div>
          </div>
          <div class=" d-flex flex-row-reverse align-items-center">
            <div class="p-2 mt-2">
              <button type="button" class="btn btn-primary" type="submit">
                <div *ngIf="loading" class="spinner-border spinner-border-sm text-light" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
                <p *ngIf="!loading">
                  Proceed
                </p>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>